import { useState, useEffect, useRef } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css';
import Header from './Header';
import userimg from "../Images/user.jpg";
import redbg from "../Images/redcolor.jpg";
import FooterLink from './FooterLink';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Select, useToast } from '@chakra-ui/react';
import {
    filterValidImageFiles,
    validateImageFileForUpload,
} from "../utils/imageUploadRules";
import {
    IMAGE_ACCEPT_ATTR,
    IMAGE_TYPES_HELPER_TEXT,
} from "../utils/validatedImageChakra";
import { INDIA_DATA } from "./indiaStatesCities"
import { validateAadharOptional, validatePanOptional } from "../utils/indiaIdValidation";
import { emptySocialMediaLinks, parseSocialMediaLinks } from "../utils/socialMediaLinks";

const UserProfile = () => {
    const toast = useToast();
    const [isEditing, setIsEditing] = useState(false);
    const login = JSON.parse(localStorage.getItem("login")) || "";
    const [editCityList, setEditCityList] = useState([]);
    const [filteredEditCities, setFilteredEditCities] = useState([]);
    const [filteredEditStates, setFilteredEditStates] = useState([]);

    const [showCityDropdown, setShowCityDropdown] = useState(false);
    const [showStateDropdown, setShowStateDropdown] = useState(false);
    const [aadharFieldError, setAadharFieldError] = useState("");
    const [panFieldError, setPanFieldError] = useState("");

    const [profileDetails, setProfileDetails] = useState({
        id: '',
        name: '',
        mobile: '',
        email: '',
        permanent_ID: '',
        profilePic: '',
        account_number: '',
        beneficary_name: '',
        ifsc_code: '',
        bank_name: '',
    });
    const url = getApiBaseUrl()

    // STORE STATE: includes existingImages (string paths), newImageFiles (File[]), removedImages (string[])
    const [storeDetails, setStoreDetails] = useState({
        id: null,
        businessDetails: {
            businessName: "",
            buildingName: "",
            landmark: "",
            area: "",
            street: "",
            city: "",
            state: "",
            pincode: "",
            description: ""
        },
        contactDetails: {
            title: "",
            personName: "",
            mobile: "",
            whatsapp: "",
            email: ""
        },
        businessTiming: { timeSlots: [] }, // array of {day, openTime, closeTime}
        paymentDetails: { beneficiaryName: "", accountNumber: "", confirmaccountNumber: "", bankName: "", ifscCode: "" },
        servicesDetails: { service: "" },
        category: "",
        subcategory: "",
        cod_percentage: "",
        additionalMobiles: [""],
        additionalWhatsapps: [""],
        additionalServices: [""],
        additionalLandlines: [""],
        additionalEmails: [""],
        google_address: "",
        location_lat: "",
        location_long: "",
        gst_avail: "",
        gst_no: "",
        aadhar_no: "",
        pan_no: "",
        socialMediaLinks: emptySocialMediaLinks(),
        existingImages: [],     // existing image paths from server
        newImageFiles: [],      // files selected for upload
        newImagePreviews: [],   // preview URLs for new images
        removedImages: [],      // names/paths of existing images user removed
    });

    const fileInputRef = useRef(null);
    const dropzoneRef = useRef(null);

    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const fetchCategoryData = async () => {
        try {
            const response = await fetch(`${url}/category/getcategory`);
            const res = await response.json();
            console.log(res);
            const activeImages = res
                .filter((image) => image.status === 'Active')
                .sort((a, b) => a.position - b.position);
            setCategories(activeImages);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchCategoryData();
    }, []);
    // ------------- FETCH user profile -------------
    const fetchDataUser = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/register/singleuser/${login.permanent_ID}`);
            const res = await response.json();
            setProfileDetails(res || {});
        } catch (error) {
            console.error("fetchDataUser:", error);
        }
    };

    // ------------- FETCH store details -------------
    const fetchStoreDetails = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/store/getstorelist/mystore/${login.permanent_ID}`);
            const data = await response.json();
            // In your API sample, data is the store object, and many fields are JSON strings
            const s = data;

            // Parse JSON-string fields safely
            const parsedBusinessDetails = s.businessDetails ? JSON.parse(s.businessDetails) : {};
            const parsedContactDetails = s.contactDetails ? JSON.parse(s.contactDetails) : {};
            const parsedBusinessTiming = s.businessTiming ? JSON.parse(s.businessTiming) : { timeSlots: [] };
            const parsedPaymentDetails = s.paymentDetails ? JSON.parse(s.paymentDetails) : {};
            const parsedServicesDetails = s.servicesDetails ? JSON.parse(s.servicesDetails) : {};
            const existingImages = s.formImages ? JSON.parse(s.formImages) : [];

            setStoreDetails(prev => ({
                ...prev,
                id: s.id,
                businessDetails: {
                    businessName: parsedBusinessDetails.businessName || "",
                    buildingName: parsedBusinessDetails.buildingName || "",
                    landmark: parsedBusinessDetails.landmark || "",
                    area: parsedBusinessDetails.area || "",
                    street: parsedBusinessDetails.street || "",
                    city: parsedBusinessDetails.city || "",
                    state: parsedBusinessDetails.state || "",
                    pincode: parsedBusinessDetails.pincode || "",
                    description: parsedBusinessDetails.description || ""
                },
                contactDetails: {
                    title: parsedContactDetails.title || "",
                    personName: parsedContactDetails.personName || "",
                    mobile: parsedContactDetails.mobile || "",
                    whatsapp: parsedContactDetails.whatsapp || "",
                    email: parsedContactDetails.email || ""
                },
                businessTiming: parsedBusinessTiming || { timeSlots: [] },
                paymentDetails: {
                    beneficiaryName: parsedPaymentDetails.beneficiaryName || "",
                    accountNumber: parsedPaymentDetails.accountNumber || "",
                    confirmaccountNumber: parsedPaymentDetails.confirmaccountNumber || "",
                    bankName: parsedPaymentDetails.bankName || "",
                    ifscCode: parsedPaymentDetails.ifscCode || ""
                },
                servicesDetails: parsedServicesDetails || { service: "" },
                category: s.category || "",
                subcategory: s.subcategory || "",
                cod_percentage: s.cod_percentage || "",
                additionalMobiles: s.additionalMobiles ? JSON.parse(s.additionalMobiles) : [""],
                additionalWhatsapps: s.additionalWhatsapps ? JSON.parse(s.additionalWhatsapps) : [""],
                additionalServices: s.additionalServices ? JSON.parse(s.additionalServices) : [""],
                additionalLandlines: s.additionalLandlines ? JSON.parse(s.additionalLandlines) : [""],
                additionalEmails: s.additionalEmails ? JSON.parse(s.additionalEmails) : [""],
                google_address: s.google_address || "",
                location_lat: s.location_lat || "",
                location_long: s.location_long || "",
                gst_avail: s.gst_avail || "",
                gst_no: s.gst_no || "",
                aadhar_no: s.aadhar_no || "",
                pan_no: s.pan_no || "",
                socialMediaLinks: parseSocialMediaLinks(s.socialMediaLinks),
                existingImages: Array.isArray(existingImages) ? existingImages : [],
                removedImages: []
            }));
            setSelectedCategory(s.category);


        } catch (err) {
            console.error("fetchStoreDetails:", err);
        }
    };

    useEffect(() => {
        fetchDataUser();
        fetchStoreDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ---------------- Profile update ----------------
    const [selectedFile, setSelectedFile] = useState(null);

    const handleProfileSave = async () => {
        const formData = new FormData();
        formData.append('name', profileDetails.name || "");
        formData.append('mobile', profileDetails.mobile || "");
        formData.append('email', profileDetails.email || "");
        formData.append('account_number', profileDetails.account_number || "");
        formData.append('beneficary_name', profileDetails.beneficary_name || "");
        formData.append('ifsc_code', profileDetails.ifsc_code || "");
        formData.append('bank_name', profileDetails.bank_name || "");
        if (selectedFile) {
            formData.append('profilePic', selectedFile);
        }

        try {
            const response = await fetch(`${getApiBaseUrl()}/register/change/${profileDetails.id}`, {
                method: 'PUT',
                body: formData,
            });

            if (response.ok) {
                await fetchDataUser();
                console.log("Profile updated");
            } else {
                console.error("Profile update failed");
            }
        } catch (err) {
            console.error("handleProfileSave:", err);
        }
    };

    const handleCategoryChange = (e) => {
        const categoryName = e.target.value;

        // Find full category object
        const selectedCat = categories.find(
            (cat) => cat.category_name === categoryName
        );

        setSelectedCategory(categoryName);

        // Store full category object
        // setCategoryArray(selectedCat);

        // Set subcategories
        // setSubCategories(selectedCat?.associatedsubcategory || []);

        // Reset subcategory
        // setSelectedSubCategory(null);
        // setSubCategoryArray({});
    };
    // ---------------- Store update ----------------
    const handleStoreSave = async () => {
        const aad = validateAadharOptional(storeDetails.aadhar_no);
        const pan = validatePanOptional(storeDetails.pan_no);
        setAadharFieldError(aad.ok ? "" : aad.message);
        setPanFieldError(pan.ok ? "" : pan.message);
        if (!aad.ok || !pan.ok) return false;

        // Build FormData for store update
        const fd = new FormData();

        fd.append("businessDetails", JSON.stringify(storeDetails.businessDetails));
        fd.append("contactDetails", JSON.stringify(storeDetails.contactDetails));
        fd.append("businessTiming", JSON.stringify(storeDetails.businessTiming));
        fd.append("paymentDetails", JSON.stringify(storeDetails.paymentDetails));
        fd.append("servicesDetails", JSON.stringify(storeDetails.servicesDetails));

        fd.append("category", storeDetails.category || "");
        fd.append("subcategory", storeDetails.subcategory || "");
        fd.append("cod_percentage", storeDetails.cod_percentage || "");

        fd.append("additionalMobiles", JSON.stringify(storeDetails.additionalMobiles || []));
        fd.append("additionalWhatsapps", JSON.stringify(storeDetails.additionalWhatsapps || []));
        fd.append("additionalServices", JSON.stringify(storeDetails.additionalServices || []));
        fd.append("additionalLandlines", JSON.stringify(storeDetails.additionalLandlines || []));
        fd.append("additionalEmails", JSON.stringify(storeDetails.additionalEmails || []));

        fd.append("google_address", storeDetails.google_address || "");
        fd.append("location_lat", storeDetails.location_lat || "");
        fd.append("location_long", storeDetails.location_long || "");

        fd.append("gst_avail", storeDetails.gst_avail || "");
        fd.append("gst_no", storeDetails.gst_no || "");
        fd.append("aadhar_no", aad.normalized || "");
        fd.append("pan_no", pan.normalized || "");
        fd.append("socialMediaLinks", JSON.stringify(storeDetails.socialMediaLinks || emptySocialMediaLinks()));

        // Send removed existing image paths so backend can delete them if needed
        fd.append("removedImages", JSON.stringify(storeDetails.removedImages || []));

        // Append new image files as formImages
        storeDetails.newImageFiles.forEach((file) => {
            fd.append("formImages", file);
        });

        try {
            const response = await fetch(`${getApiBaseUrl()}/store/update-store/${storeDetails.id}`, {
                method: "PUT",
                body: fd,
            });

            if (response.ok) {
                await fetchStoreDetails();
                setAadharFieldError("");
                setPanFieldError("");
                console.log("Store updated successfully");
                return true;
            }
            console.error("Store update failed");
            return false;
        } catch (err) {
            console.error("handleStoreSave:", err);
            return false;
        }
    };

    // Save both (profile + store) when clicking Save
    const handleSaveAll = async () => {
        await handleProfileSave();
        const storeOk = await handleStoreSave();
        if (storeOk === true) setIsEditing(false);
    };

    // ---------------- Utility handlers ----------------
    const handleProfileChange = (e) => {
        const { name, value } = e.target;
        setProfileDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) {
            setSelectedFile(null);
            return;
        }
        const r = await validateImageFileForUpload(file);
        if (!r.ok) {
            toast({
                title: "Invalid image",
                description: r.message,
                status: "error",
                duration: 6000,
                isClosable: true,
                position: "top",
            });
            return;
        }
        setSelectedFile(r.file);
    };

    // Store simple field change (non-nested)
    const handleStoreSimpleChange = (e) => {
        const { name, value } = e.target;
        if (name === "aadhar_no" && aadharFieldError) setAadharFieldError("");
        if (name === "pan_no" && panFieldError) setPanFieldError("");
        setStoreDetails(prev => ({ ...prev, [name]: value }));
    };

    // For nested businessDetails/contactDetails/paymentDetails/servicesDetails
    const handleStoreNestedChange = (section, field, value) => {
        setStoreDetails(prev => ({
            ...prev,
            [section]: { ...prev[section], [field]: value }
        }));
    };

    const handleStoreSocialChange = (key, value) => {
        setStoreDetails((prev) => ({
            ...prev,
            socialMediaLinks: { ...parseSocialMediaLinks(prev.socialMediaLinks), [key]: value },
        }));
    };

    // For arrays like additionalMobiles etc.
    const handleArrayChange = (field, index, value) => {
        setStoreDetails(prev => ({
            ...prev,
            [field]: prev[field].map((it, i) => (i === index ? value : it))
        }));
    };

    const addArrayField = (field) => {
        setStoreDetails(prev => ({ ...prev, [field]: [...(prev[field] || []), ""] }));
    };

    const removeArrayField = (field, index) => {
        setStoreDetails(prev => ({
            ...prev,
            [field]: prev[field].filter((_, i) => i !== index)
        }));
    };

    // Business timing handlers (timeSlots)
    const addTimeSlot = () => {
        setStoreDetails(prev => ({
            ...prev,
            businessTiming: { timeSlots: [...(prev.businessTiming.timeSlots || []), { day: "", openTime: "", closeTime: "" }] }
        }));
    };

    const updateTimeSlot = (index, field, value) => {
        setStoreDetails(prev => ({
            ...prev,
            businessTiming: {
                timeSlots: prev.businessTiming.timeSlots.map((slot, i) => i === index ? ({ ...slot, [field]: value }) : slot)
            }
        }));
    };

    const removeTimeSlot = (index) => {
        setStoreDetails(prev => ({
            ...prev,
            businessTiming: { timeSlots: prev.businessTiming.timeSlots.filter((_, i) => i !== index) }
        }));
    };

    // ---------------- Drag & Drop Image Upload (Option C) ----------------
    const handleFilesAdded = (files) => {
        void filterValidImageFiles(files, (msg) => {
            toast({
                title: "Invalid image",
                description: msg,
                status: "error",
                duration: 6000,
                isClosable: true,
                position: "top",
            });
        }).then((accepted) => {
            if (!accepted.length) return;
            const newPreviews = accepted.map((f) => URL.createObjectURL(f));
            setStoreDetails((prev) => ({
                ...prev,
                newImageFiles: [...prev.newImageFiles, ...accepted],
                newImagePreviews: [...prev.newImagePreviews, ...newPreviews],
            }));
        });
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer?.files?.length) {
            handleFilesAdded(e.dataTransfer.files);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onClickFileInput = () => {
        fileInputRef.current?.click();
    };

    const removeNewImage = (index) => {
        setStoreDetails(prev => {
            // revoke object URL
            const url = prev.newImagePreviews[index];
            if (url) URL.revokeObjectURL(url);
            return {
                ...prev,
                newImageFiles: prev.newImageFiles.filter((_, i) => i !== index),
                newImagePreviews: prev.newImagePreviews.filter((_, i) => i !== index)
            };
        });
    };

    const removeExistingImage = (index) => {
        setStoreDetails(prev => {
            const imagePath = prev.existingImages[index];
            return {
                ...prev,
                existingImages: prev.existingImages.filter((_, i) => i !== index),
                removedImages: [...prev.removedImages, imagePath]
            };
        });
    };

    // cleanup previews on unmount
    useEffect(() => {
        return () => {
            storeDetails.newImagePreviews.forEach(url => URL.revokeObjectURL(url));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ---------------- UI & JSX ----------------
    return (
        <>
            <Header />
            <div className="user-profile">
                <div className="my-profile">
                    <h2>My Profile</h2>
                    {isEditing ? (
                        <button onClick={handleSaveAll} className="edit-btn save">Save</button>
                    ) : (
                        <button onClick={() => setIsEditing(true)} className="edit-btn edit">Edit</button>
                    )}
                </div>

                <div className="user-profile-column">
                    <div className="user-profile-left">
                        <h2>Personal Information</h2>
                        <div className="user-profile-img">
                            <img src={redbg} alt="user-profile" className='user-profile-img1' />
                            <img
                                src={profileDetails.profilePic ? `${getApiBaseUrl()}/${profileDetails.profilePic}` : userimg}
                                alt="User"
                                className="user-profile-img2"
                            />
                        </div>

                        {isEditing && (
                            <>
                                <input type="file" accept={IMAGE_ACCEPT_ATTR} onChange={handleFileChange} className="file-input" />
                                <p className="small text-muted" style={{ marginTop: 6 }}>{IMAGE_TYPES_HELPER_TEXT}</p>
                            </>
                        )}

                        <div className="user-profile-name">
                            {isEditing ? (
                                <input type="text" name="name" value={profileDetails.name} onChange={handleProfileChange} placeholder="Enter your name" className="input-field" />
                            ) : (
                                <p className="user-name">{profileDetails.name}</p>
                            )}
                        </div>

                        <div className="user-profile-contact">
                            <p>
                                Contact: {isEditing ? (
                                    <input type="text" name="mobile" value={profileDetails.mobile} onChange={handleProfileChange} placeholder="Enter contact number" className="input-field" />
                                ) : (
                                    <span>{profileDetails.mobile}</span>
                                )}
                            </p>
                            <p>
                                Email: {isEditing ? (
                                    <input type="email" name="email" value={profileDetails.email} onChange={handleProfileChange} placeholder="Enter email" className="input-field" />
                                ) : (
                                    <span>{profileDetails.email}</span>
                                )}
                            </p>
                            <p>
                            Customer ID: {isEditing ? (
                                    <input type="text" name="permanent_ID" value={profileDetails.permanent_ID} onChange={handleProfileChange} placeholder="Enter permanent ID" className="input-field" />
                                ) : (
                                    <span>{profileDetails.permanent_ID}</span>
                                )}
                            </p>
                        </div>
                    </div>

                    <div className="user-profile-right">
                        {
                            storeDetails.id && (
                                <div className="user-profile-store">
                                    <h2>Store Details</h2>
                                    <div className="store-details">

                                        <label>Business Name</label>
                                        <input type="text" value={storeDetails.businessDetails.businessName} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("businessDetails", "businessName", e.target.value)} className="bank-input" />

                                        <label>Building Name</label>
                                        <input type="text" value={storeDetails.businessDetails.buildingName} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("businessDetails", "buildingName", e.target.value)} className="bank-input" />

                                        <label>Landmark</label>
                                        <input type="text" value={storeDetails.businessDetails.landmark} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("businessDetails", "landmark", e.target.value)} className="bank-input" />

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                            <div>
                                                <label>Area</label>
                                                <input type="text" value={storeDetails.businessDetails.area} disabled={!isEditing}
                                                    onChange={(e) => handleStoreNestedChange("businessDetails", "area", e.target.value)} className="bank-input" />
                                            </div>
                                            <div>
                                                <label>Street</label>
                                                <input type="text" value={storeDetails.businessDetails.street} disabled={!isEditing}
                                                    onChange={(e) => handleStoreNestedChange("businessDetails", "street", e.target.value)} className="bank-input" />
                                            </div>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>

                                            <div style={{ position: "relative" }}>
                                                <label>State</label>
                                                <input
                                                    type="text"
                                                    disabled={!isEditing}
                                                    value={storeDetails.businessDetails.state}
                                                    className="bank-input"
                                                    placeholder="State"
                                                    onFocus={() => setShowStateDropdown(true)}
                                                    onChange={(e) => {
                                                        const typed = e.target.value;

                                                        handleStoreNestedChange("businessDetails", "state", typed);
                                                        handleStoreNestedChange("businessDetails", "city", "");

                                                        const filtered = INDIA_DATA.filter((s) =>
                                                            s.name.toLowerCase().includes(typed.toLowerCase())
                                                        );

                                                        setFilteredEditStates(filtered);
                                                        setShowStateDropdown(true);
                                                    }}
                                                />

                                                {showStateDropdown && filteredEditStates.length > 0 && (
                                                    <div className="newstate-dropdown-box">
                                                        {filteredEditStates.map((stateObj) => (
                                                            <div
                                                                key={stateObj.id}
                                                                className="newstate-dropdown-item"
                                                                onClick={() => {
                                                                    handleStoreNestedChange("businessDetails", "state", stateObj.name);

                                                                    // Load cities for selected state:
                                                                    setEditCityList(stateObj.cities || []);
                                                                    setFilteredEditCities(stateObj.cities || []);

                                                                    setShowStateDropdown(false);
                                                                    setShowCityDropdown(false);

                                                                    // Clear city when new state selected
                                                                    handleStoreNestedChange("businessDetails", "city", "");
                                                                }}
                                                            >
                                                                {stateObj.name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            {/* CITY INPUT (dynamic dropdown) */}
                                            <div style={{ position: "relative" }}>
                                                <label>City</label>
                                                <input
                                                    type="text"
                                                    disabled={!isEditing}
                                                    value={storeDetails.businessDetails.city}
                                                    className="bank-input"
                                                    placeholder="City"
                                                    onFocus={() => setShowCityDropdown(true)}
                                                    onChange={(e) => {
                                                        const typed = e.target.value;

                                                        handleStoreNestedChange("businessDetails", "city", typed);

                                                        const filtered = editCityList.filter((c) =>
                                                            c.toLowerCase().includes(typed.toLowerCase())
                                                        );

                                                        setFilteredEditCities(filtered);
                                                        setShowCityDropdown(true);
                                                    }}
                                                />

                                                {showCityDropdown && filteredEditCities.length > 0 && (
                                                    <div className="newstate-dropdown-box">
                                                        {filteredEditCities.map((city, i) => (
                                                            <div
                                                                key={i}
                                                                className="newstate-dropdown-item"
                                                                onClick={() => {
                                                                    handleStoreNestedChange("businessDetails", "city", city);
                                                                    setShowCityDropdown(false);
                                                                }}
                                                            >
                                                                {city}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            {/* STATE INPUT (dynamic dropdown) */}


                                        </div>


                                        <label>Pincode</label>
                                        <input type="text" value={storeDetails.businessDetails.pincode} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("businessDetails", "pincode", e.target.value)} className="bank-input" />

                                        <label>Description</label>

                                        <ReactQuill
                                            theme="snow"
                                            value={storeDetails.businessDetails.description || ""}
                                            readOnly={!isEditing}

                                            onChange={(value) =>
                                                handleStoreNestedChange("businessDetails", "description", value)
                                            }
                                            placeholder="Business/Profile Description"
                                            style={{ height: "180px" }}
                                        />
                                        <label style={{ marginTop: "60px" }}>Category</label>
                                        <Select onChange={handleCategoryChange} value={selectedCategory} placeholder="Select Category">

                                            {categories.map((category) => (
                                                <option key={category.id} value={category.category_name} disabled={!isEditing}>
                                                    {category.category_name}
                                                </option>
                                            ))}
                                        </Select>
                                        {/* <input type="text" value={storeDetails.category} disabled={!isEditing}
                                            onChange={handleStoreSimpleChange} name="category" className="bank-input" /> */}

                                        {/* <label>Subcategory</label>
                                        <input type="text" value={storeDetails.subcategory} disabled={!isEditing}
                                            onChange={handleStoreSimpleChange} name="subcategory" className="bank-input" /> */}

                                        <label >Token Percentage</label>
                                        <input type="text" value={storeDetails.cod_percentage} disabled={!isEditing}
                                            onChange={handleStoreSimpleChange} name="cod_percentage" className="bank-input" />

                                        {/* ========== CONTACT DETAILS ========== */}
                                        <h3 className="sub-title">Contact Details</h3>
                                        <label>Title</label>
                                        <input type="text" value={storeDetails.contactDetails.title} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("contactDetails", "title", e.target.value)} className="bank-input" />

                                        <label>Person Name</label>
                                        <input type="text" value={storeDetails.contactDetails.personName} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("contactDetails", "personName", e.target.value)} className="bank-input" />

                                        <label>Mobile</label>
                                        <input type="text" value={storeDetails.contactDetails.mobile} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("contactDetails", "mobile", e.target.value)} className="bank-input" />

                                        <label>WhatsApp</label>
                                        <input type="text" value={storeDetails.contactDetails.whatsapp} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("contactDetails", "whatsapp", e.target.value)} className="bank-input" />

                                        <label>Email</label>
                                        <input type="email" value={storeDetails.contactDetails.email} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("contactDetails", "email", e.target.value)} className="bank-input" />

                                        {/* ========== BUSINESS TIMING ========== */}
                                        <h3 className="sub-title">Business Timing</h3>
                                        {storeDetails.businessTiming.timeSlots.map((slot, idx) => (
                                            <div key={idx} style={{ marginBottom: 8 }}>
                                                <div style={{ display: "flex", gap: 8 }}>
                                                    <select disabled={!isEditing} value={slot.day} onChange={(e) => updateTimeSlot(idx, "day", e.target.value)} className="bank-input">
                                                        <option value="">Select Day</option>
                                                        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Mon-Fri', 'Mon-Sat', 'All-Days', 'Always Open'].map(d => <option key={d} value={d}>{d}</option>)}
                                                    </select>
                                                    <input disabled={!isEditing} value={slot.openTime} onChange={(e) => updateTimeSlot(idx, "openTime", e.target.value)} className="bank-input" placeholder="Open (HH:MM)" />
                                                    <input disabled={!isEditing} value={slot.closeTime} onChange={(e) => updateTimeSlot(idx, "closeTime", e.target.value)} className="bank-input" placeholder="Close (HH:MM)" />
                                                    {isEditing && <button type="button" onClick={() => removeTimeSlot(idx)} className="remove-btn">Remove</button>}
                                                </div>
                                            </div>
                                        ))}
                                        {isEditing && <button type="button" onClick={addTimeSlot} className="add-btn">+ Add Time Slot</button>}

                                        {/* ========== PAYMENT DETAILS ========== */}
                                        <h3 className="sub-title">Payment Details</h3>
                                        <label>Beneficiary Name</label>
                                        <input type="text" value={storeDetails.paymentDetails.beneficiaryName} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("paymentDetails", "beneficiaryName", e.target.value)} className="bank-input" />

                                        <label>Account Number</label>
                                        <input type="text" value={storeDetails.paymentDetails.accountNumber} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("paymentDetails", "accountNumber", e.target.value)} className="bank-input" />

                                        <label>Confirm Account Number</label>
                                        <input type="text" value={storeDetails.paymentDetails.confirmaccountNumber} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("paymentDetails", "confirmaccountNumber", e.target.value)} className="bank-input" />

                                        <label>Bank Name</label>
                                        <input type="text" value={storeDetails.paymentDetails.bankName} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("paymentDetails", "bankName", e.target.value)} className="bank-input" />

                                        <label>IFSC Code</label>
                                        <input type="text" value={storeDetails.paymentDetails.ifscCode} disabled={!isEditing}
                                            onChange={(e) => handleStoreNestedChange("paymentDetails", "ifscCode", e.target.value)} className="bank-input" />

                                        {/* ========== ADDITIONAL ARRAYS ========== */}
                                        <h3 className="sub-title">Additional Mobiles</h3>

                                        {(storeDetails?.additionalMobiles).length > 0 && (
                                            storeDetails?.additionalMobiles.map((m, i) => (
                                                <div key={i} className="dynamic-row">
                                                    <input disabled={!isEditing} value={m} className="bank-input" onChange={(e) => handleArrayChange("additionalMobiles", i, e.target.value)} placeholder={`Mobile ${i + 1}`} />
                                                    {isEditing && <button type="button" className="remove-btn" onClick={() => removeArrayField("additionalMobiles", i)}>×</button>}
                                                </div>
                                            )))}
                                        {isEditing && <button type="button" className="add-btn" onClick={() => addArrayField("additionalMobiles")}>+ Add Mobile</button>}

                                        <h3 className="sub-title">Additional WhatsApp</h3>
                                        {Array.isArray(storeDetails?.additionalWhatsapps) &&
                                            storeDetails.additionalWhatsapps.some(item => item?.trim() !== "") && (
                                                storeDetails.additionalWhatsapps.map((m, i) => (
                                                    <div key={i} className="dynamic-row">
                                                        <input
                                                            disabled={!isEditing}
                                                            value={m}
                                                            className="bank-input"
                                                            onChange={(e) => handleArrayChange("additionalWhatsapps", i, e.target.value)}
                                                            placeholder={`WhatsApp ${i + 1}`}
                                                        />
                                                        {isEditing && (
                                                            <button
                                                                type="button"
                                                                className="remove-btn"
                                                                onClick={() => removeArrayField("additionalWhatsapps", i)}
                                                            >
                                                                ×
                                                            </button>
                                                        )}
                                                    </div>
                                                ))
                                            )}

                                        {isEditing && <button type="button" className="add-btn" onClick={() => addArrayField("additionalWhatsapps")}>+ Add WhatsApp</button>}

                                        <h3 className="sub-title">Additional Services</h3>
                                        {storeDetails?.additionalServices.map((s, i) => (
                                            <div key={i} className="dynamic-row">
                                                <input disabled={!isEditing} value={s} className="bank-input" onChange={(e) => handleArrayChange("additionalServices", i, e.target.value)} placeholder={`Service ${i + 1}`} />
                                                {isEditing && <button type="button" className="remove-btn" onClick={() => removeArrayField("additionalServices", i)}>×</button>}
                                            </div>
                                        ))}
                                        {isEditing && <button type="button" className="add-btn" onClick={() => addArrayField("additionalServices")}>+ Add Service</button>}

                                        <h3 className="sub-title">Additional Landlines</h3>
                                        {storeDetails?.additionalLandlines.map((l, i) => (
                                            <div key={i} className="dynamic-row">
                                                <input disabled={!isEditing} value={l} className="bank-input" onChange={(e) => handleArrayChange("additionalLandlines", i, e.target.value)} placeholder={`Landline ${i + 1}`} />
                                                {isEditing && <button type="button" className="remove-btn" onClick={() => removeArrayField("additionalLandlines", i)}>×</button>}
                                            </div>
                                        ))}
                                        {isEditing && <button type="button" className="add-btn" onClick={() => addArrayField("additionalLandlines")}>+ Add Landline</button>}

                                        <h3 className="sub-title">Additional Emails</h3>
                                        {(storeDetails?.additionalEmails).map((em, i) => (
                                            <div key={i} className="dynamic-row">
                                                <input disabled={!isEditing} value={em} className="bank-input" onChange={(e) => handleArrayChange("additionalEmails", i, e.target.value)} placeholder={`Email ${i + 1}`} />
                                                {isEditing && <button type="button" className="remove-btn" onClick={() => removeArrayField("additionalEmails", i)}>×</button>}
                                            </div>
                                        ))}
                                        {isEditing && <button type="button" className="add-btn" onClick={() => addArrayField("additionalEmails")}>+ Add Email</button>}

                                        {/* ========== GST & Location ========== */}
                                        <h3 className="sub-title">GST & Location</h3>
                                        <label>GST Available</label>
                                        <select
                                            name="gst_avail"
                                            value={storeDetails.gst_avail}
                                            disabled={!isEditing}
                                            onChange={(e) => handleStoreSimpleChange(e)}
                                            className="bank-input"
                                        >
                                            <option value="">Select</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>


                                        {storeDetails.gst_avail === "yes" && (
                                            <>
                                                <label>GST Number</label>
                                                <input
                                                    type="text"
                                                    name="gst_no"
                                                    value={storeDetails.gst_no}
                                                    disabled={!isEditing}
                                                    onChange={(e) => handleStoreSimpleChange(e)}
                                                    className="bank-input"
                                                />
                                            </>
                                        )}

                                        <label>Enter Aadhar Number <span style={{ fontWeight: 400, color: '#666' }}>(optional)</span></label>
                                        <input
                                            type="text"
                                            name="aadhar_no"
                                            value={storeDetails.aadhar_no}
                                            disabled={!isEditing}
                                            onChange={(e) => handleStoreSimpleChange(e)}
                                            placeholder="Enter a valid Aadhar Number"
                                            className="bank-input"
                                            autoComplete="off"
                                            style={aadharFieldError ? { borderColor: "#c53030", borderWidth: 2 } : undefined}
                                        />
                                        {aadharFieldError ? (
                                            <div style={{ color: "#c53030", fontSize: 13, marginTop: 4 }}>{aadharFieldError}</div>
                                        ) : null}
                                        <label>Enter Pan Number <span style={{ fontWeight: 400, color: '#666' }}>(optional)</span></label>
                                        <input
                                            type="text"
                                            name="pan_no"
                                            value={storeDetails.pan_no}
                                            disabled={!isEditing}
                                            onChange={(e) => handleStoreSimpleChange(e)}
                                            placeholder="Enter a valid Pan Number"
                                            className="bank-input"
                                            autoComplete="off"
                                            style={panFieldError ? { borderColor: "#c53030", borderWidth: 2 } : undefined}
                                        />
                                        {panFieldError ? (
                                            <div style={{ color: "#c53030", fontSize: 13, marginTop: 4 }}>{panFieldError}</div>
                                        ) : null}

                                        <h3 className="sub-title">Social media &amp; IMDb <span style={{ fontWeight: 400, color: '#666', fontSize: '0.9em' }}>(optional)</span></h3>
                                        {[
                                            { key: "facebook", label: "Facebook URL" },
                                            { key: "instagram", label: "Instagram URL" },
                                            { key: "twitter", label: "X (Twitter) URL" },
                                            { key: "youtube", label: "YouTube URL" },
                                            { key: "linkedin", label: "LinkedIn URL" },
                                            { key: "imdb", label: "IMDb profile URL" },
                                        ].map(({ key, label }) => (
                                            <div key={key} style={{ marginBottom: 10 }}>
                                                <label>{label}</label>
                                                <input
                                                    type="url"
                                                    value={(storeDetails.socialMediaLinks && storeDetails.socialMediaLinks[key]) || ""}
                                                    disabled={!isEditing}
                                                    onChange={(e) => handleStoreSocialChange(key, e.target.value)}
                                                    placeholder="https://"
                                                    className="bank-input"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        ))}

                                        <label>Google Address</label>
                                        <input type="text" value={storeDetails.google_address} disabled={!isEditing} onChange={(e) => handleStoreSimpleChange(e)} name="google_address" className="bank-input" />

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                            <div>
                                                <label>Latitude</label>
                                                <input type="text" value={storeDetails.location_lat} disabled={!isEditing} onChange={(e) => handleStoreSimpleChange(e)} name="location_lat" className="bank-input" />
                                            </div>
                                            <div>
                                                <label>Longitude</label>
                                                <input type="text" value={storeDetails.location_long} disabled={!isEditing} onChange={(e) => handleStoreSimpleChange(e)} name="location_long" className="bank-input" />
                                            </div>
                                        </div>

                                        {/* ========== IMAGE UPLOADER (Drag & Drop) ========== */}
                                        <h3 className="sub-title">Store Images</h3>

                                        {/* Existing images grid */}
                                        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
                                            {storeDetails.existingImages.map((imgPath, i) => (
                                                <div key={i} style={{ width: 100, height: 100, position: 'relative', borderRadius: 6, overflow: 'hidden', background: '#f2f2f2' }}>
                                                    <img src={`${getApiBaseUrl()}/${imgPath}`} alt={`store-${i}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    {isEditing && (
                                                        <button type="button" onClick={() => removeExistingImage(i)} style={{ position: 'absolute', right: 6, top: 6, background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: 4, padding: '2px 6px', cursor: 'pointer' }}>X</button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Dropzone for new images */}
                                        <div
                                            ref={dropzoneRef}
                                            onDrop={isEditing ? handleDrop : undefined}
                                            onDragOver={isEditing ? handleDragOver : undefined}
                                            style={{
                                                border: '2px dashed #ddd',
                                                padding: 12,
                                                borderRadius: 8,
                                                cursor: isEditing ? 'pointer' : 'default',
                                                marginBottom: 8,
                                                display: 'flex',
                                                gap: 10,
                                                alignItems: 'center',
                                                flexWrap: 'wrap'
                                            }}
                                            onClick={isEditing ? onClickFileInput : undefined}
                                        >
                                            <input
                                                ref={fileInputRef}
                                                type="file"
                                                accept={IMAGE_ACCEPT_ATTR}
                                                multiple
                                                style={{ display: 'none' }}
                                                onChange={(e) => {
                                                    handleFilesAdded(e.target.files);
                                                    e.target.value = "";
                                                }}
                                            />
                                            <div style={{ flex: 1 }}>
                                                {isEditing ? (
                                                    <div>
                                                        <div>Drag & drop images here, or click to select</div>
                                                        <p className="small text-muted" style={{ marginTop: 6 }}>{IMAGE_TYPES_HELPER_TEXT}</p>
                                                    </div>
                                                ) : (
                                                    <div>Images</div>
                                                )}
                                            </div>

                                            {/* previews of newly added images */}
                                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                {storeDetails.newImagePreviews.map((p, i) => (
                                                    <div key={i} style={{ width: 80, height: 80, position: 'relative', borderRadius: 6, overflow: 'hidden', background: '#fafafa' }}>
                                                        <img src={p} alt={`new-${i}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                        {isEditing && <button type="button" onClick={() => removeNewImage(i)} style={{ position: 'absolute', right: 4, top: 4, background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: 4, padding: '2px 6px', cursor: 'pointer' }}>X</button>}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )
                        }


                        {/* ========== BANK DETAILS (profile) ========== */}
                        {
                            !storeDetails.id && (
                                <div className="user-profile-bank" style={{ marginTop: 20 }}>
                                    <h2>
                                        Bank Details
                                        {!profileDetails.account_number && (
                                            <span style={{ marginLeft: 10, color: '#c00', fontWeight: 600 }}>
                                                <i className="fa-solid fa-exclamation"></i> Update Your Bank Details
                                            </span>
                                        )}
                                    </h2>
                                    <div className="bank-details">
                                        <input type="text" name="beneficary_name" value={profileDetails.beneficary_name} onChange={handleProfileChange} placeholder="Beneficiary's name" className="bank-input" disabled={!isEditing} />
                                        <input type="text" name="account_number" value={profileDetails.account_number} onChange={handleProfileChange} placeholder="Account Number" className="bank-input" disabled={!isEditing} />
                                        <input type="text" name="ifsc_code" value={profileDetails.ifsc_code} onChange={handleProfileChange} placeholder="IFSC Code" className="bank-input" disabled={!isEditing} />
                                        <input type="text" name="bank_name" value={profileDetails.bank_name} onChange={handleProfileChange} placeholder="Bank Name" className="bank-input" disabled={!isEditing} />
                                    </div>
                                </div>
                            )
                        }
                        {/* <div className="user-profile-bank" style={{ marginTop: 20 }}>
                            <h2>
                                Bank Details
                                {!profileDetails.account_number && (
                                    <span style={{ marginLeft: 10, color: '#c00', fontWeight: 600 }}>
                                        <i className="fa-solid fa-exclamation"></i> Update Your Bank Details
                                    </span>
                                )}
                            </h2>
                            <div className="bank-details">
                                <input type="text" name="beneficary_name" value={profileDetails.beneficary_name} onChange={handleProfileChange} placeholder="Beneficiary's name" className="bank-input" disabled={!isEditing} />
                                <input type="text" name="account_number" value={profileDetails.account_number} onChange={handleProfileChange} placeholder="Account Number" className="bank-input" disabled={!isEditing} />
                                <input type="text" name="ifsc_code" value={profileDetails.ifsc_code} onChange={handleProfileChange} placeholder="IFSC Code" className="bank-input" disabled={!isEditing} />
                                <input type="text" name="bank_name" value={profileDetails.bank_name} onChange={handleProfileChange} placeholder="Bank Name" className="bank-input" disabled={!isEditing} />
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>

            <FooterLink />
        </>
    );
};

export default UserProfile;
